<template>
    <div class="manager_dashboard">
        <user-menu />
        <div class="wrapper">
            <div class="content-wrapper">
                <div class="container-wrapper center">
                    <div>
                        <h3 class="text-center heading">Select a Location</h3>
                    </div>
                    <div class="heading-seperator"></div>
                    <div class="margin-bottom-10"></div>
                    <div class="row justify-content-lg-center">
                        <div class="col-6 mt-4">
                            <div class="row ea-row" v-for="(item, index) in locations" :key="index">
                                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                    <div class="ea-card-box">
                                        <div class="loc_item_1">
                                            <img src="@/assets/enterprise/branded_location_icon.png" width="32">
                                        </div>
                                        <div class="loc_item_2">
                                            <div class="account-name">{{ item.accountName }}</div>
                                            <div class="account-address">{{ formatAddress(item.city, item.stateName) }}</div>
                                            <div class="account-address">
                                                <span class="font-weight-bold">{{formatGroupTitle(item.groupsAssigned)}}</span>
                                                {{ formatGroup(item.groupsAssigned) }}
                                            </div>
                                        </div>
                                        <div class="loc_item_3 mt-4" @click="setCurrentLocation(item)">
                                            <img src="@/assets/enterprise/right-chevron-blue.png" width="32">
                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import router from '../router/index.js';
import store from '../store/store.js';
import UserMenu from './shared/user_menu.vue';
export default {
    data() {
        return {
            roles: [],
            admin_role_flag: '',
            manager_role_flag: '',
            mentor_role_flag: '',
            mentee_role_flag: '',
            apprentice_role_flag: '',
            instructor_role_flag: '',
            student_role_flag: '',
            enterprise_admin_role_flag: '',
            locations: [],
            userAccounts: {
                isUserLinkedMultipleLocations: false,
                locations: [],
            },
        }
    },
    components: {
        UserMenu,
    },
    methods: {
        formatAddress(city, state) {
            var address = '';
            if (city) {
                address += city + ", ";
            }
            if (state) {
                address += state + ", ";
            }
            return address.slice(0, -2);
        },
        formatGroupTitle(groups) {
            if (groups.length > 0) {
                if (groups.length == 1) {
                    return "Mentor: ";
                } else if (groups.length > 1) {
                    return "Mentors: ";
                }
            } else {
                return "";
            }
        },
        formatGroup(groups) {
            var group_names = "";
            for(var m = 0; m < groups.length; m++) {
                group_names+= groups[m]['name'] + ", ";
            }
            if (group_names) {
                return group_names.slice(0, -2);
            } else {
                return "";
            }
        },
        setCurrentLocation(item) {
            this.$store.dispatch('set_user_accountid', item.accId);
            this.$store.dispatch('set_user_locations', this.userAccounts);
            this.saveUserLoggedTime();
            this.userRedirection();
        },
        navigate(path) {
            router.push(path);
            location.reload();
        },
        isInArray(value, array) {
            return array.indexOf(value) > -1;
        },
        userRedirect: function(role) {
            var url = '';
            if(role == 'Manager') {
                url = "/company-admin-dashboard";
            }
            else if(role == 'Mentor') {
                url = "/mentor-dashboard";
            }
            else if(role == 'Mentee') {
                url = "/mentee-dashboard";
            }
            else if(role == 'Primary Admin') {
                url = "/school-admin-dashboard";
            }
            else if(role == 'Instructor') {
                url = "/students-tasks-list";
            }
            return url;
        },
        userRedirection: function() {
            this.roles = this.$store.state.roles;
            if(this.roles) {
                this.admin_role_flag = this.isInArray('ROLE_MASTER_ADMIN', this.roles);
                this.manager_role_flag = this.isInArray('ROLE_ADMIN', this.roles);
                this.mentor_role_flag = this.isInArray('ROLE_MENTOR', this.roles);
                this.mentee_role_flag = this.isInArray('ROLE_MENTEE', this.roles);
                this.apprentice_role_flag = this.isInArray('ROLE_APPRENTICE', this.roles);
                this.instructor_role_flag = this.isInArray('ROLE_INSTRUCTOR', this.roles);
                this.student_role_flag = this.isInArray('ROLE_STUDENT', this.roles);
                this.enterprise_admin_role_flag = this.isInArray('ROLE_ENTERPRISE_ADMIN', this.roles);
                if(this.$store.state.switch_flag) {
                    var url = this.userRedirect(this.$store.state.switch_flag);
                    this.navigate(url);
                }
                else if(this.admin_role_flag === true) {
                    this.navigate("/admin-dashboard");
                }
                else if(this.manager_role_flag === true) {
                    if(this.$store.state.school_flag == 1) {
                        this.navigate("/school-admin-dashboard");
                    }
                    else {
                        this.navigate("/company-admin-dashboard");
                    }
                }
                else if(this.mentor_role_flag === true) {
                    this.navigate("/mentor-dashboard");
                }
                else if(this.mentee_role_flag === true) {
                    this.navigate("/mentee-dashboard");
                }
                else if(this.apprentice_role_flag === true) {
                    this.navigate("/apprentice-dashboard");
                }
                else if(this.instructor_role_flag === true) {
                    this.navigate("/students-tasks-list");
                }
                else if(this.student_role_flag === true) {
                    this.navigate("/student-dashboard");
                } else if(this.enterprise_admin_role_flag === true) {
                    this.navigate("/enterprise-admin-dashboard")
                }
                return true;
            }
        },
        saveUserLoggedTime() {
            var currentdate = new Date(); 
            var currentDateTime = currentdate.getFullYear() + "-"
                                    + (currentdate.getMonth()+1)  + "-" 
                                    +  currentdate.getDate() + " "  
                                    + currentdate.getHours() + ":"  
                                    + currentdate.getMinutes() + ":" 
                                    + currentdate.getSeconds();
            
            this.$store.dispatch('set_multi_user_logged_time', currentDateTime);
        }
    },
    created() {
        if (this.$store.state.user_locations.isUserLinkedMultipleLocations) {
            this.userAccounts.isUserLinkedMultipleLocations = this.$store.state.user_locations.isUserLinkedMultipleLocations;
            this.userAccounts.locations = this.$store.state.user_locations.locations;
            this.locations = this.$store.state.user_locations.locations;
        }
    }
}
</script>
<style scoped>
.page_title { font-size: 1rem; font-weight: 900; text-align: center;}
.ea-row { margin-bottom: 0.5rem; }
.ea-card-box {
  background-color: #FFF !important;
  margin-bottom: 0.5rem;
  border-radius: 0.5rem;
  padding: 10px;
}
.loc_item_1 { width: 10%; float: left; }
.loc_item_2 { width: 80%; float: left; color:#7d7d7d; }
.loc_item_3 { width: 10%; float: left; cursor: pointer; }
.account-name { margin-bottom: 0rem; font-weight: 900; font-size: 0.9rem; }
.account-address { margin-bottom: 1rem; }
</style>


// WEBPACK FOOTER //
// src/components/user_select_location.vue